module.exports = __webpack_public_path__ + "img/forward.1cf3b8a7.png";